






import { PromBannerData } from '@/types';
import { biHottag, windowHelper } from '@tencent/ppd-base-libs';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { checkBlackList } from './business';

@Component
export default class BlackListBanner extends Vue {
  @Prop() bannerData!: PromBannerData;
  public isShowBanner = false;
  async created() {
    const { blackListAckListId, blackListQryType, bannerBrow } = this.bannerData;
    if (!blackListAckListId || !blackListQryType) {
      // 如果banner不在配置中，直接展示
      this.isShowBanner = true;
    } else {
      const isShowBalckListBanner = await checkBlackList({ actListId: blackListAckListId, qryType: blackListQryType });
      this.isShowBanner = isShowBalckListBanner;
    }
    if (this.isShowBanner && bannerBrow) {
      biHottag(bannerBrow);
    }
    console.log('=showbanner', this.isShowBanner);
  }

  handleBannerClick() {
    if (this.isShowBanner) {
      const { bannerClick, link } = this.bannerData;
      biHottag(bannerClick);
      windowHelper.redirect(link, 300);
    }
  }
}
